import React from 'react'
import { usePutRequest } from '../../../hooks/request'
import { USERS_DETAIL } from '../../../urls'
import UsersForm from './UsersForm'

export default function UsersUpdate({ onCancel, onSuccess, item }) {
    const brandUpdate = usePutRequest({ url: USERS_DETAIL.replace('{id}', item.id) })

    async function onSubmit(data) {
        const { success } = await brandUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered">
                <b>Изменить</b>
            </h1>
            <UsersForm loading={brandUpdate.loading} initialValues={item} onSubmit={onSubmit}
                onCancel={onCancel} />
        </div>
    )
}
